// extracted by mini-css-extract-plugin
export default {"center-form":"auth_center-form__PA7bE","guest":"auth_guest__AI3Ek","form-button":"auth_form-button__jIhZD"};